import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const ForecastText = styled(TextBase)`
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[2]};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NetRevenueValue = styled(TextBase)`
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[1]};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  height: 58px;
  padding: 10px 12px;
  box-sizing: border-box;
`;
